import React from "react";
import MinifiedProductPanel$ from "@deosite/components-new/MinifiedProductPanel";
import OptionsSelector from "../OptionsSelector";
import Button from "@deosite/components-new/buttons/Button";
import QuantityPicker from "../quantityPickers/QuantityPicker";

const MinifiedProductPanel = props => {
  const propsExt = {
    ...props,
    optionsSelector: <OptionsSelector />,
    toCartButton: <Button sx={{ minWidth: ["160px", null, null, "100%"] }} />,
    qtyPicker: <QuantityPicker />
  };
  return <MinifiedProductPanel$ {...propsExt} />;
};

export default MinifiedProductPanel;
